export type Lang = 'hr' | 'en';

type Keys =
  | 'payerInfo'
  | 'paymentInfo'
  | 'processingSuccess'
  | 'processingCancel'
  | 'redirecting'
  | 'cancelError'
  | 'loadingPayment'
  | 'redirectingToPayment'
  | 'paymentDone'
  | 'paymentFailed'
  | 'missingAccess'
  | 'transactionDone'
  | 'retry'
  | 'noPaymentsDisplayed'
  | 'buttonPay'
  | 'cartFines'
  | 'cartFees'
  | 'welcomeMessage'
  | 'paymentDescriptionFines'
  | 'paymentDescriptionFinesAndFees'
  | 'classNumber'
  | 'serialNumber'
  | 'userInstructions';

export const translations: Record<Lang, Record<Keys, string>> = {
  hr: {
    payerInfo: 'Informacije o platitelju',
    paymentInfo: 'Informacije o plaćanju',
    processingSuccess: 'Obrađujemo uspješno plaćanje',
    processingCancel: 'Obrađujemo otkazano plaćanje',
    redirecting: 'Preusmjeravamo vas',
    cancelError: 'Greška pri odustajanju od plaćanja',
    loadingPayment: 'Učitava informacije o plaćanju',
    redirectingToPayment: 'Preusmjerava na plaćanje',
    paymentDone: 'Uplata uspješno provedena',
    paymentFailed: 'Plaćanje nije uspješno provedeno',
    missingAccess: 'Nemate sve pristupne podatke',
    transactionDone: 'Transakcija uspješno provedena',
    retry: 'Pokušaj ponovo', 
    noPaymentsDisplayed: 'Nema plaćanja za prikaz',
    buttonPay: 'Plati',
    cartFines: 'Novčane kazne',
    cartFees: 'Troškovi postupka',
    welcomeMessage: 'Dobrodošli na MUP portal za plaćanje',
    paymentDescriptionFines:'Opis plaćanja: Plaćanje novčane kazne po ',
    paymentDescriptionFinesAndFees:'Opis plaćanja: Plaćanje novčane kazne i troškova postupka po ',
    classNumber: 'klasi',
    serialNumber: 'serijskom broju',
    userInstructions: 'Korisničke upute'
},
  en: {
    payerInfo: 'Payer Information',
    paymentInfo: 'Payment Information',
    processingSuccess: 'Processing successful payment.',
    processingCancel: 'Processing cancelled payment.',
    redirecting: 'You are being redirected.',
    cancelError: 'Payment cancellation error',
    loadingPayment: 'Loading payment details',
    redirectingToPayment: 'Redirecting you to payment.',
    paymentDone: 'Payment completed successfully',
    paymentFailed: 'Payment was not successfully completed',
    missingAccess: 'You don’t have all the required access data',
    transactionDone: 'Transaction completed successfully',
    retry: 'Retry',
    noPaymentsDisplayed: 'No payments to display',
    buttonPay: 'Pay' ,
    cartFines: 'Monetary fines',
    cartFees: 'Procedure costs', 
    welcomeMessage: 'Welcome to the MUP payment portal',
    paymentDescriptionFines:'Payment description: Payment of a monetary fine ',
    paymentDescriptionFinesAndFees:'Payment description: Payment of a monetary fine and procedure costs ',
    classNumber: 'by class',
    serialNumber: 'by serial number',
    userInstructions: 'User manual'
  },
};